import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import SecureLS from "secure-ls";
import { jwtDecode } from "jwt-decode";
import UnauthorizedAccess from "../pages/UnauthorizedAccess";
import { canAccessRoute } from "../utils/routeAuthorization";

const ls = new SecureLS({ encodingType: "aes" });

const ProtectedRoutes = () => {
  const location = useLocation();
  const user = ls.get("user");
  const authToken = ls.get("authToken");

  if (!user || !authToken) {
    return <Navigate to="/login" replace />;
  }

  try {
    const decodedToken = jwtDecode(authToken);
    const currentTime = Date.now() / 1000;

    if (decodedToken.exp < currentTime) {
      ls.remove("user");
      ls.remove("authToken");
      return <Navigate to="/login" replace />;
    }
  } catch (error) {
    ls.remove("user");
    ls.remove("authToken");
    return <Navigate to="/login" replace />;
  }

  if (!canAccessRoute({ user, pathname: location.pathname })) {
    return <UnauthorizedAccess />;
  }

  return <Outlet />;
};

export default ProtectedRoutes;
